import { NgModule } from '@angular/core'

import { BugReportLauncherComponent } from './components/bug-report-launcher/bug-report-launcher.component'
import { BugReportDialogComponent } from './components/bug-report-dialog/bug-report-dialog.component'
import { SharedModule } from '@shared/shared.module'

//* Módulo propio y no dos declaraciones más en AppModule porque esta es la primera pieza del panel
//* que se monta en el SHELL y no en una ruta: encapsularla deja AppModule con una línea en vez de
//* dos declaraciones sueltas. Hay precedente directo con WalletConfigModule y AlgorithmConfigModule.
//*
//* SharedModule ya exporta todo lo que hace falta (Dialog, InputText, InputTextarea, Button, Toast,
//* Tooltip, FontAwesome y ReactiveForms): cero imports de PrimeNG nuevos.
@NgModule({
  declarations: [BugReportLauncherComponent, BugReportDialogComponent],
  imports: [SharedModule],
  exports: [BugReportLauncherComponent],
})
export class BugReportModule {}
